import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { consumeTokenFromUrl } from './lib/auth';
import { WorkspaceProvider } from './lib/workspace';
import { HelpProvider } from './lib/help';

// 2026 redesign — Anthropic CI type stack:
//   Poppins → display + h1-h6 (per Anthropic brand guidelines, ≥24pt).
//   Lora    → body (per Anthropic brand guidelines).
// Source Serif 4 + Inter retained as fallbacks for components that
// opted into font-serif / font-sans before the CI swap.
// IBM Plex Mono kept for numerals/IDs, Big Shoulders for tactical pills.
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/lora/400.css';
import '@fontsource/lora/500.css';
import '@fontsource/lora/600.css';
import '@fontsource/lora/400-italic.css';
import '@fontsource-variable/source-serif-4';
import '@fontsource-variable/inter';
import './index.css';

// Grab token from URL on first load, store in sessionStorage
consumeTokenFromUrl();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <WorkspaceProvider>
          <HelpProvider>
            <App />
          </HelpProvider>
        </WorkspaceProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
